module.exports = __webpack_public_path__ + "img/horizontal_4_5_5012.d6011b54.png";